import { h } from "preact";

import i18n from "../../i18n";
import { getText, getValue } from "../../helpers.js";

import Button from "../Button.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import Tag from "../Tag.jsx";
import UploadedListItem from "../UploadedListItem.jsx";
import WhitepaperTeaser from "../WhitepaperTeaser.jsx";

export default {
  regulated_profession_check_summary: ({ answers, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>regulated_profession_check</HeaderIcon>
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem overline="Professional title">
              {getText(answers.occupation)}
            </ListItem>
            <ListItem overline="Regulation">
              {getValue(answers.professionIsRegulated)
                ? "The profession is regulated in Germany"
                : "The profession is not regulated in Germany"}
            </ListItem>
          </List>
          <List class="mb-32">
            <UploadedListItem value={getValue(answers.recognitionPdf)} />
            {!getValue(answers.recognitionIsMandatory) && (
              <ListItem iconFront="check">
                Recognition is not necessary to be able to work in your
                profession.
              </ListItem>
            )}
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },

  regulated_profession_check_start: ({ onNext }) => {
    return (
      <section class="task-page">
        <HeaderIcon>regulated_profession_check</HeaderIcon>
        <h1 class="task-page__headline">Regulated profession check</h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem number={1}>
              Visit the online portal{" "}
              <Tag
                iconFront="language"
                to="https://www.anerkennung-in-deutschland.de/html/en/skilled-workers.php"
                target="_blank"
              >
                Recognition in Germany
              </Tag>
              .
            </ListItem>
            <ListItem number={2}>Enter your profession.</ListItem>
            <ListItem number={3}>
              Answer all questions about your job, education, and place of work.
            </ListItem>
            <ListItem number={4}>
              Save the result page as pdf using the button at the bottom.
            </ListItem>
            <ListItem number={5}>Inform Nioomi about the result.</ListItem>
          </List>
          <List>
            <ListItem
              secondLine={
                <span>
                  Do you prefer a personal consultation?
                  <br />
                  You can call the Recognition in Germany hotline from Monday to
                  Friday, 8 am to 6 pm.
                </span>
              }
            >
              Tipp
            </ListItem>
            <ListItem iconFront="phone">
              <a href="tel:+493018151111" class="subtle">
                +49 30 1815-1111
              </a>
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-32"
            title="Qualification"
            description={i18n.t("whitepaperTeaser.qualification")}
            whitepaperId="degree-recognition-in-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
        </div>
      </section>
    );
  },
};
